<div class="components-summary-content">
  <p-card>
    <ng-template pTemplate="header">
      <span class="p-card-title">Components Summary</span>
      <span [formGroup]="filters">
        <p-dropdown
          formControlName="repairType"
          name="selectedRepairType"
          [options]="chepRepairTypes">
        </p-dropdown>
        <p-toggleButton formControlName="showAll" offLabel="Show All Rows" onLabel="Hide Rows"></p-toggleButton>
      </span>
    </ng-template>
    <div *ngIf="loading" class="centered">
      <i class="pi pi-spin pi-spinner"></i>
      Calculating...
    </div>
    <p-table *ngIf="componentsSummary"
      [value]="filteredRows | async"
      styleClass="scrolltable"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template pTemplate="header">
      <tr>
          <th>Component Type</th>
          <th>Repair Type</th>
          <th>Beginning Inventory</th>
          <th>Received</th>
          <th>Transferred</th>
          <th>Ending Inventory</th>
          <th>Usage</th>
      </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
      <tr>
          <td>{{ (getProduct(row.productId) | async) || '&lt;unknown&gt;' }}</td>
          <td>{{ getType(row.sortActivity) }}</td>
          <td>{{ row.startingInventory }}</td>
          <td>{{ row.receivedUnits }}</td>
          <td>{{ row.transferredUnits }}</td>
          <td>{{ row.endingInventory }}</td>
          <td [class.positive]="row.usage > 0"
              [class.negative]="row.usage < 0">{{ row.usage }}</td>
      </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="totals">
          <td>Lumber Totals</td>
          <td></td>
          <td>{{ sumLumberTotal('startingInventory') | async }}</td>
          <td>{{ sumLumberTotal('receivedUnits') | async }}</td>
          <td>{{ sumLumberTotal('transferredUnits') | async }}</td>
          <td>{{ sumLumberTotal('endingInventory') | async }}</td>
          <td>{{ sumLumberTotal('usage') | async }}</td>
        </tr>
        <tr class="totals">
          <td>All Components Totals</td>
          <td></td>
          <td>{{ sumTotal('startingInventory') | async }}</td>
          <td>{{ sumTotal('receivedUnits') | async }}</td>
          <td>{{ sumTotal('transferredUnits') | async }}</td>
          <td>{{ sumTotal('endingInventory') | async }}</td>
          <td>{{ sumTotal('usage') | async }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
